var root = require('./_root');

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;



/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/~/lodash/_Uint8Array.js
 ** module id = 749
 ** module chunks = 0
 **/